export const name = "ST_NUMGEOMETRIES";
export const summary = `Gets the number of geometries in a \`GEOGRAPHY\` value.`;
export const reference = `
## ST_NUMGEOMETRIES

Gets the number of geometries in a \`GEOGRAPHY\` value.

\`\`\`
ST_NUMGEOMETRIES(geography_expression)
\`\`\`

### Description

Returns the number of geometries in the input \`GEOGRAPHY\`. For a single point, linestring, or polygon, \`ST_NUMGEOMETRIES\` returns \`1\`. For any collection of geometries, \`ST_NUMGEOMETRIES\` returns the number of geometries making up the collection. \`ST_NUMGEOMETRIES\` returns \`0\` if the input is the empty\`GEOGRAPHY\`.


### Return type

\`INT64\`


### Example

The following example computes \`ST_NUMGEOMETRIES\` for a single point geography, two collections, and an empty geography.



\`\`\`
WITH example AS(
  SELECT ST_GEOGFROMTEXT('POINT(5 0)') AS geography
  UNION ALL
  SELECT ST_GEOGFROMTEXT('MULTIPOINT(0 1, 4 3, 2 6)') AS geography
  UNION ALL
  SELECT ST_GEOGFROMTEXT('GEOMETRYCOLLECTION(POINT(0 0), LINESTRING(1 2, 2 1))') AS geography
  UNION ALL
  SELECT ST_GEOGFROMTEXT('GEOMETRYCOLLECTION EMPTY'))
SELECT
  geography,
  ST_NUMGEOMETRIES(geography) AS num_geometries,
FROM example;

/*------------------------------------------------------+----------------*
 | geography | num_geometries |
 +------------------------------------------------------+----------------+
 | POINT(5 0) | 1 |
 | MULTIPOINT(0 1, 4 3, 2 6) | 3 |
 | GEOMETRYCOLLECTION(POINT(0 0), LINESTRING(1 2, 2 1)) | 2 |
 | GEOMETRYCOLLECTION EMPTY | 0 |
 *------------------------------------------------------+----------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
